import { MaterialAutocomplete, TextField } from 'form';
import { Grid, Typography } from 'ui';

export const MaterialSection = () => {
  return (
    <>
      <Typography variant="h5">Material</Typography>
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <TextField label="Tonnes" type="number" name="tonnes" required />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField label="Tonnes / load" type="number" required name="tonnes_per_load" />
        </Grid>
        <Grid item xs={12} md={6}>
          <MaterialAutocomplete label="Material" name="material" required />
        </Grid>
      </Grid>
    </>
  );
};
